import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonProjectView, CommonProjectTopics } from "../../CommonComponents/CommonProjectViews";

export const ProjectRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.project().root,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectView />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectTopics />;
    },
};
